import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonControlTooltipDirective } from './common-control-tooltip.directive';
import { CommonControlTooltipScreenComponent } from './components/common-control-tooltip-screen.component';

@NgModule({
	imports: [
		CommonModule
	],
	declarations: [
		CommonControlTooltipDirective,
		CommonControlTooltipScreenComponent
	],
	exports: [
		CommonControlTooltipDirective
	]
})
export class CommonControlTooltipModule {}

